/**
 * _resend_link.js — the in-page "send the confirm link again" request, shared
 * by every button that offers it: the Send gate's prompt in the email modal
 * (pdf_email_preview_controller.js), the Getting started checklist
 * (onboarding_checklist_controller.js) and the send prompt card
 * (onboard_send_controller.js). Each button keeps its own look; only the
 * request and what it answers live here.
 *
 * Posts JSON to /auth/resend-verification, which mails the business owner
 * taken from the session, never an address from the page. Answers
 * { ok, message } in the server's own words (the address it mailed, the rate
 * limit's message, or why it could not send). Never throws.
 */

const REFUSED = 'Could not send the verification email.';
const UNREACHABLE = 'Could not send the verification email. Please try again.';

export async function resendConfirmLink() {
    try {
        const data = await window.api('/auth/resend-verification', {
            method: 'POST',
            body: {},
            notifyError: false,
            throwOnError: false,
        });
        return { ok: Boolean(data?.success), message: data?.message || REFUSED };
    } catch {
        return { ok: false, message: UNREACHABLE };
    }
}
